import { studySongActionTypes } from './Constants';

export function generateSongRequest(data) {
	return {
		type: studySongActionTypes.GENERATE_SONG_REQUEST,
		payload: {
			data,
		},
	};
}

export function generateSongSuccess(data) {
	return {
		type: studySongActionTypes.GENERATE_SONG_SUCCESS,
		payload: {
			data,
		},
	};
}

export function generateSongError() {
	return {
		type: studySongActionTypes.GENERATE_SONG_ERROR,
	};
}

export function clearState() {
	return {
		type: studySongActionTypes.CLEAR_AI_SONG_STATE,
	};
}

export function getSongDetailsRequest(songId) {
	return {
		type: studySongActionTypes.GET_SONG_DETAILS_REQUEST,
		payload: {
			songId,
		},
	};
}

export function getSongDetailsSuccess(data) {
	return {
		type: studySongActionTypes.GET_SONG_DETAILS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getSongDetailsError() {
	return {
		type: studySongActionTypes.GET_SONG_DETAILS_ERROR,
	};
}

export function favoriteUnfavoriteSongRequest(songId, isFavorite) {
	return {
		type: studySongActionTypes.FAVORITE_UNFAVORITE_SONG_REQUEST,
		payload: {
			songId,
			isFavorite,
		},
	};
}

export function favoriteUnfavoriteSongSuccess(isFavorite) {
	return {
		type: studySongActionTypes.FAVORITE_UNFAVORITE_SONG_SUCCESS,
		payload: {
			isFavorite,
		},
	};
}

export function favoriteUnfavoriteSongError() {
	return {
		type: studySongActionTypes.FAVORITE_UNFAVORITE_SONG_ERROR,
	};
}
